//defautl PRODUCER_PHONE_NUMBER
export const PRODUCER_PHONE_NUMBER = '+18643324036'; // Default producer phone number
